import { Action } from '@ngrx/store';
import { NavigationExtras } from '@angular/router';

export const RouterActionType = {
  RouterGo: '[Router] RouterGo',
  RouterBack: '[Router] RouterBack',
  RouterForward: '[Router] RouterForward',
};

export interface RouterGoPayload {
  path: any[];
  query?: object;
  extras?: NavigationExtras;
}

export class RouterGo implements Action {
  readonly type = RouterActionType.RouterGo;
  constructor(public payload: RouterGoPayload) { }
}

export class RouterBack implements Action {
  readonly type = RouterActionType.RouterBack;
  constructor() { }
}

export class RouterForward implements Action {
  readonly type = RouterActionType.RouterForward;
  constructor() { }
}


export type RouterAction = RouterGo
  | RouterBack
  | RouterForward
  ;
